export const CEFR_LEVELS = ['A1', 'A2', 'B1', 'B2', 'C1', 'C2'] as const;

export type ICEFRLevel = (typeof CEFR_LEVELS)[number];
